import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const AnimatedHeartHero = () => {
  const { t } = useTranslation();
  const [isFontLoaded, setIsFontLoaded] = useState(false);
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => {
    // Verificar si la fuente está cargada
    const checkFont = async () => {
      try {
        await document.fonts.load('400 1em "Great Vibes"');
        setIsFontLoaded(true);
        // Asegurarnos de que los textos se establezcan después de cargar la fuente
        setTitle(t("hero.Title").trim());
        setDate(t("hero.Date").trim());
      } catch (error) {
        console.error('Error loading font:', error);
        setIsFontLoaded(true);
        setTitle(t("hero.Title").trim());
        setDate(t("hero.Date").trim());
      }
    };

    checkFont();
  }, [t]);

  return (
    <div className="w-full h-full">
      <svg
        viewBox="0 0 24 24"
        className="w-full h-full"
        style={{
          animation: "pulse 1.5s infinite",
        }}
      >
        <defs>
          <linearGradient id="heartGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f6d885" />
            <stop offset="100%" stopColor="#eab128" />
          </linearGradient>
        </defs>
        <path
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
          fill="url(#heartGradient)"
          stroke="#6d503a"
          strokeWidth="0.8"
        />
        
        <g style={{ opacity: isFontLoaded ? 1 : 0 }}>
          <text
            x="12"
            y="9"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#6d503a"
            fontSize="2.8"
            fontWeight="bold"
            stroke="white"
            strokeWidth="0.1"
            paintOrder="stroke"
            fontFamily="'Great Vibes', cursive"
          >
            {title}
          </text>
          
          <text
            x="12"
            y="12"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#6d503a"
            fontSize="2.3"
            stroke="white"
            strokeWidth="0.1"
            paintOrder="stroke"
            fontFamily="'Great Vibes', cursive"
          >
            {date}
          </text>
        </g>
      </svg>

      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.2); }
        }
        
        @font-face {
          font-family: 'Great Vibes';
          font-style: normal;
          font-weight: 400;
          font-display: block;
          src: url(https://fonts.gstatic.com/s/greatvibes/v18/RWmMoKWR9v4ksMfaWd_JN9XKiaQ6DQ.woff2) format('woff2');
        }
      `}</style>
    </div>
  );
};

export default AnimatedHeartHero; 